import { makeStyles } from '@material-ui/core/styles';
/**
 *
 * Material UI styles for TextAreaField
 *
 *
 * @see https://material-ui.com/styles/basics
 *
 */

const useStyles = makeStyles(theme => ({
  inputRoot: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1.25, 0.875, 1.375, 0.875),
  },
  root: {
    margin: theme.spacing(3),
  },
  textfield: {
    width: '100%',
  },
}));

export default useStyles;
